import TableVM from '../table-vm';
import GradebookServices from '../services';
export default Kadenze.Util.extendObj(TableVM, function(coursework_id) {
  var self = this;
  self.$el = $('#grades-tab-content');
  self.filter_options = ko.observable({'submissions': ['ungraded', 'partially_graded', 'not_submitted', 'submitted', 'student_action_required']});
  if (Kadenze.isKadenze)
    self.filter_options()['students'] = ['auditor', 'certificate'];
  self.params = {
    filters: ko.observableArray([]),
    page: ko.observable(1),
    page_size: ko.observable(20),
    search: ko.observable('')
  };
  self.coursework_id = ko.observable();
  self.student_ids = ko.observableArray([]);
  self.students = ko.observableArray([]);

  self.initUI = function() {
    var $searchEl = $('#gradesSearch');
    $searchEl.on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $searchEl.blur();
      }
    });
  };

  self.bindFilters = function () {
    _.each(_.keys(self.params), function (key) {
      self.params[key].subscribe(self.filterChanged, self);
    });
  };

  self.getSheet = function(url, params) {
    params = params ? params : ko.mapping.toJS(self.params);
    url = url ? url : Kadenze.Routes.show_course_gradebook_grades_path(self.course_id, 'coursework', self.coursework_id(), params);

    self.students([]);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
      console.warn('Error retrieving sheet data:', xhr);
    });

    request.always(function(data) {
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.pageChanged.bind(self));
    });

    return request;
  };

  self.bindData = function(data) {
    self.student_ids(data.student_ids);

    self.paginator(data.paginator);

    if (self.student_ids().length > 0) {
      self.mp = new Mprogress({
        template: 1,
        start: true,
        parent: '#' + self.$el.attr('id') + ' .display-table'
      });

      self.getStudent(self.student_ids()[0]);

      self.hidePlaceholder();
    } else {
      self.showPlaceholder('no_results');
    }
  };

  self.getStudent = function(student_id) {
    var url = Kadenze.Routes.show_row_course_gradebook_grades_path(self.course_id, self.coursework_id(), student_id);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      var mapped_student = ko.mapping.fromJS(data);
      self.students.push(mapped_student);

      var completion = self.students().length / self.student_ids().length;
      self.mp.set(completion);
      if (completion == 1) {
        self.mp.end();
      } else {
        var index = self.student_ids.indexOf(student_id);
        self.getStudent(self.student_ids()[index + 1]);
      }
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_grades_path(self.course_id, {subject: 'coursework', subject_id: self.coursework_id()});
    GradebookServices.sendRequest(url, 'POST', self.$el);
    Kadenze.Analytics.track('grade', 'download', {type: 'coursework_grades'});
  };

  self.openSubmission = function (item, event) {
    var msg = 'Are you sure you want to allow {first_name} {last_name} to submit {coursework}'.supplant(
      {first_name: item.student_data.first_name(), last_name: item.student_data.last_name(), coursework: item.coursework_data.name()});
    GradebookServices.openSubmission(item, event, msg);
  };

  self.markAsSubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'submitted');
  };

  self.markAsUnsubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'unsubmitted');
  };

  self.downloadSubmission = function (item, event) {
    GradebookServices.downloadSubmission(item, event);
  };

  self.showSpeedGrader = function (item, event) {
    GradebookServices.initSpeedGrader(item, event, self.params.filters(), function () {
      //Refresh student row after close
      var url = Kadenze.Routes.show_row_course_gradebook_grades_path(self.course_id, self.coursework_id(), item.student_data.id());
      GradebookServices.sendRequest(url, 'GET', self.$el).done(function (data) {
        _.each(_.keys(data), function (key) {
          if (ko.isObservable(item[key]))
            item[key](data[key]);
        });
      });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Coursework.GradesVM');
    that.course_id = $('#course_id').val();
    that.showPlaceholder('loading');
    that.bindFilters();

    that.coursework_id.subscribe(that.filterChanged, that);
    that.coursework_id(coursework_id);
  }(this);
});

